<template>
  <el-table-column v-if="editable===false"
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
    class="numeric"
  />
  <el-table-column v-else
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
    class="numeric"
  >
    <template slot-scope="scope">
      <el-form-item
        :prop="tableDataName + '.' + scope.$index + '.' + prop"
        :rules="rules"
      >
          <!-- :value="getter(scope.row[prop])" -->
        <el-input-number
          class="no-spin"
          v-model="scope.row[prop]"
          @input="setter"
          :controls="controls"
          controls-position="right"
          type="text"
          :clearable="true"
          resize="none"
          :maxlength="maxlength"
          :placeholder="placeholder"
          :disabled="disabled === true ? disabled : addRowMode === false ? disabled : !changeable(addRowMode, changeCase, tableDataCount, scope.$index)"
          :min="min"
          :max="max"
          :precision="precision"
          :step="step"
          :autofocus="autofocus"
        >
        </el-input-number>
      </el-form-item>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    label: {
      type: String,
      default: 'テキスト長'
    },
    prop: {
      type: String,
      default: 'text'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 4
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999999999
    },
    precision: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    width: {
      type: String,
      default: ''
    },
    addRowMode: {
      type: Boolean,
      default: false
    },
    changeable: {
      type: Function,
      default: () => true
    },
    changeCase: {
      type: String,
      default: ''
    },
    tableDataCount: {
      type: Number,
      default: 0
    },
    tableDataName: {
      type: String,
      default: 'tableData'
    },
    controls: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    rules: {
      get () {
        const rules = []
        // if (!this.disabled) {
        if (this.required) {
          rules.push(this.validatorRequired(this.label, 'blur'))
        }
        // }
        return rules
      }
    }
  },
  mounted () {
    const root = document.documentElement
    root.style.setProperty('--width', this.width)
  },
  methods: {
    getter (value) {
      if (value === null) {
        return undefined
      }
      return value
    },
    setter (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
:root {
  --width: 100px;
}
.el-table {
  th,
  td {
    &.text-column {
      width: var(--width);
    }
  }
}
</style>
